import { Box, Grid } from '@mui/material';
import { FC, useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import {
	getErrorCorrectionRequest,
	getErrorTypesRequest,
} from 'redux/reducers/errorCorrections/reducer';
import { ErrorDescription } from './ErrorDescription';
import { ErrorCorrection } from './ErrorCorrection';
import { AdditionalInformation } from './AdditionalInformation';
import { PreviousErrors } from './PreviousErrors';

export const ErrorItem: FC = () => {
	const dispatch = useDispatch();
	const params = useParams<{ errorId?: string }>();
	const { errorId } = params;
	useEffect(() => {
		if (!errorId) return;
		dispatch(getErrorCorrectionRequest({ errorId: +errorId }));
	}, [dispatch, errorId]);

	useEffect(() => {
		dispatch(getErrorTypesRequest());
	}, [dispatch]);

	return (
		<Box
			sx={{
				padding: '0 10px',
			}}
		>
			<Grid container spacing={2}>
				<Grid item sm={5}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: 2,
						}}
					>
						<ErrorDescription />
						<AdditionalInformation />
					</Box>
				</Grid>
				<Grid item sm={7}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: 2,
						}}
					>
						<ErrorCorrection />
						<PreviousErrors />
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};
